import React, { useState } from 'react';

import { Drawer, Grid, IconButton, Link } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import styleDrawer from '../../themes/drawerDefault';

const useStyles = styleDrawer;

export default function TemporaryDrawer({ buttonHead, children, iconButtonAction, labeButtonAction, title, submitButtonLabel, headerButton }) {
  const classes = useStyles();
  const [state, setState] = useState({ right : false });
  localStorage.setItem('adireto-drawer-open', true);
  const toggleDrawer = (side, open) => event => {
      if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }
      setState({ ...state, [side] : open });
  };

  const DrawerHeader = () => {
    return (
      <>
        <div className={classes.drawerHead}>
          <Grid container spacing={0}>
            <Grid item xs={12}>
              <h2>
                <IconButton onClick={toggleDrawer('right', false)} style={{padding : 6}}>
                  <CloseIcon />
                </IconButton>
                {title}
              </h2>
            </Grid>
          </Grid>
        </div>
      </>
    );
  };

  const LabelButton = () => {
    return (
      <Link onClick={toggleDrawer('right', true)}>
        {labeButtonAction}
      </Link>
    );
  }

  return (
    <>
      <LabelButton />
      <Drawer anchor="right" open={state.right} onClose={toggleDrawer('right', false)}>
        <div className={classes.boxDrawer} role="presentation">
          <Grid container spacing={0} className={classes.containerDrawer}>
            <Grid item xs={12}>
              <DrawerHeader />
              <div className={classes.drawerBody}>
                {children}
              </div>
            </Grid>
          </Grid>
        </div>
      </Drawer>
    </>
  );
};